import { render, staticRenderFns } from "./OSection.vue?vue&type=template&id=84552446"
import script from "./OSection.vue?vue&type=script&lang=js"
export * from "./OSection.vue?vue&type=script&lang=js"
import style0 from "./OSection.vue?vue&type=style&index=0&id=84552446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports